/**
 * Unicode and non-Latin character-aware base64 encoding helper.
 */
export function base64Decode(str: string): string {
  return decodeURIComponent(escape(atob(str)));
}
